gsap.registerPlugin(ScrollTrigger);

const initBrandGrid = () => {
  const gridItems = document.querySelectorAll('.brand-grid__item');
  
  const random = (min, max) => Math.random() * (max - min) + min;
  
  const shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  
  gridItems.forEach(item => {
    // ランダム値の範囲を狭める
    const startX = random(-200, 200);  // 500→200
    const startY = random(-200, 200);  // 500→200
    const startZ = random(-100, 0);    // -500→-100
    const startRotateX = random(-90, 90); // 180→90
    const startRotateY = random(-90, 90); // 180→90
    const startRotateZ = random(-90, 90); // 180→90

    gsap.set(item, {
      opacity: 0,
      scale: 0,
      x: startX,
      y: startY,
      z: startZ,
      rotationX: startRotateX,
      rotationY: startRotateY,
      rotationZ: startRotateZ,
    });
  });

  const itemsArray = Array.from(gridItems);
  const shuffledItems = shuffleArray([...itemsArray]);
  
  shuffledItems.forEach((item, index) => {
    gsap.to(item, {
      opacity: 1,
      scale: 1,
      x: 0,
      y: 0,
      z: 0,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      duration: 0.8,
      delay: index * 0.01, 
      ease: "back.out(0.2)",
      scrollTrigger: {
        trigger: item,
        start: "top bottom-=20",
        once: true,
        // マーカーを追加してデバッグ可能に
        // markers: true 
      }
    });
  });
};

// Shopifyのセクションのロードとアンロードのイベントリスナー
document.addEventListener('shopify:section:load', initBrandGrid);
initBrandGrid();